"use client"

import { forwardRef, useCallback, useImperativeHandle, useState } from "react"
import { Modal } from "antd"
import { getLocalizedText } from "../utils/getLocalizedText"
// import { sanitizeFaqHtml } from "../utils/sanitizeFaqHtml"
import { sanitizeCmsHtml } from "@/utils/html/sanitizeCmsHtml"
import type { FaqDto } from "../types"

export type FaqDetailModalRef = {
  open: (faq: FaqDto) => void
  close: () => void
}

type FaqDetailModalProps = {
  locale: string
}

const FaqDetailModal = forwardRef<FaqDetailModalRef, FaqDetailModalProps>(({ locale }, ref) => {
  const [open, setOpen] = useState(false)
  const [faq, setFaq] = useState<FaqDto | null>(null)

  const handleOpen = useCallback((next: FaqDto) => {
    setFaq(next)
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => ({ open: handleOpen, close: handleClose }), [handleOpen, handleClose])

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      title={faq ? getLocalizedText(faq.question, locale) : ""}
      afterClose={() => setFaq(null)}
      className="faq-detail-modal"
    >
      {faq && (
        <div
          className="faq-detail-modal__answer prose rich-text"
          dangerouslySetInnerHTML={{ __html: sanitizeCmsHtml(getLocalizedText(faq.answer, locale)) }}
        />
      )}
    </Modal>
  )
})

FaqDetailModal.displayName = "FaqDetailModal"

export default FaqDetailModal
